export enum QuizResultFilterType {
	All = 'all',
	Submitted = 'submitted',
	AutoSubmitted = 'auto submitted',
	NotSubmitted = 'not submitted',
	Pending = 'pending',
	Inprogress = 'in progress'
}